<script>
import pfMixin from '../../../../mixins/pfMixin'
export default {
	mixins: [pfMixin],
	components: {
		PfModal: () => import(/* webpackChunkName: "pf-modal" */ '../PfModal'),
		PfLoader: () => import(/* webpackChunkName: "pf-loader" */ '../PfLoader'),
	},
	props: ['client', 'analysis', 'name'],

	data() {
		return {
			cliente: null,
			datos: {
				notas: ''
			},
			config: {
			events: {
				initialized: function () {
					console.log('initialized')
				}
				}
			},
			model: 'Edit Your Content Here!',
			hide: {
				strikethrough: true,
				table: true
			}
		}
	},
	watch: {
		client: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'cliente', newData)
			},
			deep: true,
			immediate: true
		},
		analysis: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'datos', {...newData.datos})
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		addMP() {
			this.datos.mercado_productos.push({
				cliente: '',
				cliente_productos: '',
				nac_ext: '',
				ventas: '',
				proveedor: '',
				proveedor_productos: '',
				nac_imp: '',
				volumen: '',
				competidores: '',
				part_mdo: ''
			})
		},
		removeMP(index) {
			this.datos.mercado_productos.splice(index, 1)
		}
	}
}
</script>
<template>
	<div class="pb-5">
		<div class="pf-analysis__header py-3">
			<div class="d-flex align-items-center">
				<span class="pf-tag pf-tag--success">{{cliente.estado}}</span> 
				<h4 class="mb-0">{{cliente.datos.nombre}}</h4>
				<!-- <button @click="$refs.loaderModal.open(3000)">showLoader</button> -->
			</div>
			<div class="ml-auto">
				<h5 class="mb-0">Renovación del PF: {{cliente.datos.nombre}}</h5>
			</div>
		</div>
		<div class="d-flex align-items-center py-3">
			<div class="d-flex align-items-center">
				<h4 class="">Business Risk</h4>
			</div>
			<div class="ml-auto">
				<button class="btn btn-light btn-sm rounded-0 font-weight-bold" @click="save()"> <span class="icon-computer-folder"></span> Guardar</button>
				<button class="btn btn-light btn-sm rounded-0 font-weight-bold ml-1"> <span class="icon-refresh"></span> Actualizar</button>
			</div>
			
		</div>

		<div id="accordion_br" class="pf-accordion  pb-3">
			<div class="card">
				<div class="card-header p-1" id="br_h_1">
					<button class="btn btn-link d-block btn-block p-0 text-left" data-toggle="collapse" data-target="#br_1" aria-expanded="true" aria-controls="br_1">
						Mercado Productos
					</button>
				</div>

				<div id="br_1" class="collapse show" aria-labelledby="br_h_1" data-parent="#accordion_br">
					<div class="card-body">
						<div class="d-flex flex-wrap">
							<div class="col-12">
								<div class="pf-table-container">
									<table class="table pf-table-odd  table-bordered">
										<tbody>
											<tr>
												<th></th>
												<th class="text-center font-weight-bold">CLIENTES</th>
												<th class="text-center font-weight-bold">PRODUCTOS</th>
												<th class="text-center font-weight-bold">NAC/EXT</th>
												<th class="text-center font-weight-bold">% <br> VENTAS</th>
												<th class="text-center font-weight-bold">PROVEEDORES</th>
												<th class="text-center font-weight-bold">PRODUCTOS</th>
												<th class="text-center font-weight-bold">NAC/IMP</th>
												<th class="text-center font-weight-bold">% <br> VOLUMEN</th>
												<th class="text-center font-weight-bold">COMPETIDORES</th>
												<th class="text-center font-weight-bold">% PART. <br> MDO.</th>
											</tr>
											<tr v-for="(item, index) in datos.mercado_productos" :key="`br_mp_${index}`">
												<td class="p-1">
													<button class="btn btn-light p-1 text-primary" @click="removeMP(index)"><span class="icon-trash"></span></button>
												</td>
												<td class="p-1">
													<input class="pf-control__input w-100" type="text" v-model="item.cliente">
												</td>
												<td class="p-1">
													<input class="pf-control__input w-100" type="text" v-model="item.cliente_productos">
												</td>
												<td class="p-1">
													<select class="pf-control__input" style="width: 150px" type="text" v-model="item.nac_ext">
														<option value="">--Seleccione--</option>
														<option value="NAC">NAC</option>
														<option value="EXT">EXT</option>
													</select>
												</td>
												<td class="p-1">
													<input class="pf-control__input" style="width: 100px" type="text" v-model="item.ventas">
												</td>
												<td class="p-1">
													<input class="pf-control__input w-100" type="text" v-model="item.proveedor">
												</td>
												<td class="p-1">
													<input class="pf-control__input"  type="text" v-model="item.proveedor_productos">
												</td>
												<td class="p-1">
													<select class="pf-control__input"  style="width: 150px" type="text" v-model="item.nac_imp">
														<option value="">--Seleccione--</option>
														<option value="NAC">NAC</option>
														<option value="IMP">IMP</option>
													</select>
												</td>
												<td class="p-1">
													<input class="pf-control__input" style="width: 100px" type="text" v-model="item.volumen">
												</td>
												<td class="p-1">
													<input class="pf-control__input"  type="text" v-model="item.competidores">
												</td>
												<td class="p-1">
													<input class="pf-control__input text-right" style="width: 80px" type="text" v-model="item.volumen">
												</td>
											</tr>
										</tbody>
									</table>

								</div>
								<div class="mt-3">
									<button class="btn btn-light btn-sm rounded-0 font-weight-bold" @click="addMP"><span class="icon-blank-page"></span> Nuevo Registro</button>
								</div>
								<div class="d-flex justify-content-end">
									<div class="d-flex mr-2">
										CRS: <input type="text" class="pf-control__input text-right" style="width: 70px" v-model="datos.crs">
									</div>
									<div class="d-flex">
										Ciclo Económico: 
										<select v-model="datos.ciclo_economico" class="pf-control__input">
											<option value="">--Selecciona--</option>
											<option value="Crecimiento">Crecimiento</option>
											<option value="Desacelaración">Desacelaración</option>
											<option value="Recesión">Recesión</option>
										</select>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				
			</div>
			<div class="card">
				<div class="card-header p-1" id="br_h_2">
					<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" data-target="#br_2" aria-expanded="true" aria-controls="br_2">
						Posición Competitiva y Valoración
					</button>
				</div>
				<div id="br_2" class="collapse show" aria-labelledby="br_h_1" data-parent="#accordion_br">
					<div class="col-12 mx-auto mt-3">
						<label class="pf-control d-flex">
							<span class="pf-control__label">Posición Competitiva y Valoración</span>
							<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
						</label>	
						<quill-editor
						ref="myQuillEditor"
						v-model="datos.posicion_cometitiva_y_valoracion"
						@change="$parent.updatedForms"
						/>
					</div>	
				</div>
			</div>
		
		</div>
		<div class="pf-controls-flow">
			<div class="container">
				<div class="d-flex">
					<div class="ml-auto pf-controls-flow__button">
						<button class="btn btn-light btn-sm rounded-0 font-weight-bold"  @click="save()"> <span class="icon-computer-folder"></span> Guardar</button>
						<button class="btn btn-light btn-sm rounded-0 font-weight-bold ml-1"> <span class="icon-refresh"></span> Actualizar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>